import React from "react";
import {TableCell, TableRow} from "@mui/material";
import {useTranslation} from "react-i18next";
import InCareNetHFService from "../../../services/InCareNetHFService";
import {InCareNetHFTableData} from "../../../models/InCareNetHF";
import {LMColumn} from "../../Tables/types";

interface ICNSummaryFooterProps {
  columns: LMColumn[];
  tableData: InCareNetHFTableData[];
  hasSelection: boolean;
}

/**
 * Device-count totals row rendered inside the table's own <TableFooter>.
 *
 * Because it lives in the same <Table> as the data, the cells line up with the
 * columns automatically — the previous implementation had to reconstruct column
 * widths from the DataGrid's apiRef and manually scroll-sync a floating footer.
 */
export default function ICNSummaryFooter({columns, tableData, hasSelection}: Readonly<ICNSummaryFooterProps>) {
  const {t} = useTranslation();
  const aggregationColumns = InCareNetHFService.deviceCountColumns;

  const cellSx = {fontWeight: "bold", position: "sticky", bottom: 0, bgcolor: "background.paper"} as const;

  return (
    <TableRow>
      {hasSelection && <TableCell padding="checkbox" sx={cellSx}/>}
      {columns.map((column) => {
        if (column.field === "customerName") {
          return (
            <TableCell key={column.field} sx={cellSx}>
              {`${t("map.total")}:`}
            </TableCell>
          );
        }

        const isAggregated = aggregationColumns.includes(column.field);
        return (
          <TableCell key={column.field} sx={cellSx}>
            {isAggregated ? InCareNetHFService.aggregateDeviceCount(tableData, column) : null}
          </TableCell>
        );
      })}
    </TableRow>
  );
}
